import React, {Component} from 'react';
import { ScrollView } from 'devextreme-react';
import ProductionCustomer from '../ProductionCustomer/ProductionCustomer';



export const getHeight = () => {
    return (window.innerHeight - 185)
  }


class ProductionCustomerHolder extends Component {
    render() {
        return (
            <ScrollView height={getHeight()}>
               <ProductionCustomer></ProductionCustomer>
            </ScrollView>
        ) 
        
    }
}

export default ProductionCustomerHolder